import styled, {ThemeProps} from 'styled-components';
import {Theme} from './../../../stories/theme/types';

export const SrpMainWrapper = styled.section(
  props => `
    width: 100%;
    display: flex;
    background-color: ${props.theme.colors.white.bgWhite};
    padding: ${props.theme.spacing.large.l20} 0;
`);

export const SrpMainInnerWrapper = styled.section(
  props =>`
    width: 100%;
    max-width: 120rem;
    margin: 0 auto;
    display: flex;
    background-color: ${props.theme.colors.white.bgWhite};
`);

export const RightSectionWrapperStyle = styled.section(
  props => `
    display: flex;
    flex-direction: column;
    width: 80%;
    padding-left: ${props.theme.spacing.large.l40};
`);

export const LeftSectionWrapperStyle = styled.section(
  (props: ThemeProps<Theme>) => `
    width: 20%;
    align-self: flex-end;
    position: sticky;
    bottom: ${props.theme.spacing.large.l20};
`);

export const GoSafeCardBlockWrapper = styled.div(
  props => `
    margin-bottom: ${props.theme.spacing.base};
    border: .1rem solid ${props.theme.colors.grey.lightef};
    border-radius: ${props.theme.misc.borderRadius.xxlarge};
  `,
);
